import * as React from 'react';
import classnames from 'classnames';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import './inspirational-materials-scroll-arrow.scss';

type Props = {
  direction: 'prev' | 'next',
  isDisabled: boolean,
  isHidden: boolean,
  onClick: () => void
};

const InspirationalMaterialsScrollArrow = (
  {
    direction,
    isHidden,
    isDisabled,
    onClick
  }: Props
): JSX.Element => {
  const arrowClasses = classnames('inspirational-materials-scroll-arrow', {
    'inspirational-materials-scroll-arrow--hidden': isHidden,
    'inspirational-materials-scroll-arrow--disabled': isDisabled
  });
  const chevron = direction === 'prev'
    ? 'chevron-left-custom-fg'
    : 'chevron-right-custom-fg';

  return (
    <div
      className={arrowClasses}
      onClick={!isDisabled ? onClick : undefined}
    >
      <SVGDynamicIcon
        name={chevron}
        width={6}
        height={13}
        customColor="black"
      />
    </div>
  );
};

export default InspirationalMaterialsScrollArrow;
